import React from "react";

import "./RouteContent.scss";

const RouteContent: React.FC = ({ children }) => <div className="c-route-content">{children}</div>;

export default RouteContent;
